export default "__VITE_ASSET__DHUv$Rhl__"